var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalizationBg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 454,
    viewBox: "0 0 335 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 103L3 24.6C3 12.6706 12.6706 3 24.6 3L103 3",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3 103L3 24.6C3 12.6706 12.6706 3 24.6 3L103 3",
    stroke: "url(#paint0_linear_2749_15291)",
    strokeWidth: 5,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 103L3 24.6C3 12.6706 12.6706 3 24.6 3L103 3",
    stroke: "#EE7622",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M332 351V429.4C332 441.329 322.329 451 310.4 451H232",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332 351V429.4C332 441.329 322.329 451 310.4 451H232",
    stroke: "url(#paint1_linear_2749_15291)",
    strokeWidth: 5,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332 351V429.4C332 441.329 322.329 451 310.4 451H232",
    stroke: "#EE7622",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2749_15291",
    x1: 230.259,
    y1: 142.975,
    x2: 7.30433,
    y2: 336.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2749_15291",
    x1: 104.741,
    y1: 311.025,
    x2: 327.696,
    y2: 117.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalizationBg2);
export default __webpack_public_path__ + "static/media/DigitalizationBg2.ce355f8a2a71cf980e0b3958593ffd37.svg";
export { ForwardRef as ReactComponent };